import { render } from "./DetailArticle.vue?vue&type=template&id=622fa566&scoped=true"
import script from "./DetailArticle.vue?vue&type=script&lang=js"
export * from "./DetailArticle.vue?vue&type=script&lang=js"

import "./DetailArticle.vue?vue&type=style&index=0&id=622fa566&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622fa566"]])

export default __exports__